export const environment = {
  production: true,
  TDS_URL: window.location.protocol + '//' + window.location.hostname,
  REST_URL:'/models/services/REST/index.cfm/',
  oAuthEnabled: true,
  testUserName: '',
  testUserPassword: '',
  programBrochureAssetsFolder: '_assets/angular/program_brochure/assets/',
  programWizardAssetsFolder: '_assets/angular/program_wizard/assets/',
  programTemplateAssetsFolder: '_assets/angular/program_template/assets/',
  programDiscoveryAssetsFolder: '_assets/angular/program_discovery/assets/',
  assetsFolder: '_assets/angular/program_application/assets/',
  googleAPIKey: 'AIzaSyCCGe0at0uAoc8aq2jYkUsStstYZgCTCGI',
  disableRuleDeploymentActivation: false,
  showBetaWarnings: true,
  showAnalyticsLinkOnlyForSuperUsers: false
};
